import Vue from 'vue'
import App from './App.vue'
import AppMobile from './AppMobile.vue'

import Row from 'element-ui/lib/row'
import Col from 'element-ui/lib/col'
import Dialog from 'element-ui/lib/dialog'
import Container from 'element-ui/lib/container'
import Header from 'element-ui/lib/header'
import Aside from 'element-ui/lib/aside'
import Main from 'element-ui/lib/main'
import Footer from 'element-ui/lib/footer'
import Popover from 'element-ui/lib/popover'
import Message from 'element-ui/lib/message'
import MessageBox from 'element-ui/lib/message-box'
import Scrollbar from 'element-ui/lib/scrollbar'

import VueClipboard from 'vue-clipboard2'
import VueBus from 'vue-bus'
import isMobile from './common/isMobile.js'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/js/jquery-3.6.0.min'
import './assets/js/jquery.qrcode.min.js'
import global_ from './components/Global'
import VueResource from 'vue-resource'
import VueLazyload from 'vue-lazyload'

import jocommon from './components/maincontent/body/common/index.js'
import jocommonmobile from './componentsMobile/maincontent/body/common/index.js'

var Bus = new Vue()

Vue.use(Row)
Vue.use(Col)
Vue.use(Dialog)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Popover)
Vue.use(Scrollbar)

Vue.use(VueClipboard)
Vue.use(VueBus)
Vue.use(VueResource)
Vue.use(VueLazyload, {
  error:require('./assets/img/error-50px.svg'),
  loading: require('./assets/img/onloading.gif'),
  adapter: {
    loaded ({ el, naturalWidth, src }) {
      // eslint-disable-next-line no-undef
      $(el).css('width', '')
      // eslint-disable-next-line no-undef
      let width = $(el).attr('data-width')
      if (width && !isNaN(width) && width!==0) {
        // eslint-disable-next-line no-undef
        $(el).width($(el).attr('data-width'))
      }
    }
  }
})

Vue.config.productionTip = false
Vue.prototype.GLOBAL = global_
Vue.prototype.$message = Message
Vue.prototype.$alert = MessageBox.alert;
//控制tab页签名的中英文显示
// Vue.prototype.RcLanguage = ''

//控制topbar显示
Vue.prototype.showTopbar = true;
Vue.prototype.showLink = true;
Vue.prototype.showTrans = false;
Vue.prototype.layout = "";
//不显示topbar时选择显示的组件
Vue.prototype.component = 'maincontent';
Vue.prototype.showBaidu = true;
Vue.prototype.showGoogle = false;
Vue.prototype.hideFootnote = false;
// Vue.prototype.isBilingual = true;

Vue.prototype.isMobile = isMobile;
let hideCopyright = 0
let _renderArticle = () => {
  let articleTitle = ''
  if (Vue.prototype.ARTICLE.titlegroup && Vue.prototype.ARTICLE.titlegroup.articletitle && Vue.prototype.ARTICLE.titlegroup.articletitle.length > 0) {
    let articleTitleData = Vue.prototype.ARTICLE.titlegroup.articletitle[0].data
    _title(articleTitleData)
  }
  if (Vue.prototype.ARTICLE.hideLink === 1 ) {
    Vue.prototype.showLink = false
  }
  document.title = articleTitle
  parseParam();
  if (isMobile) {
    Vue.use(jocommonmobile)
    require('./assets/css/commonMobile.scss')
    new Vue({
      render: h => h(AppMobile)
    }).$mount('#app')
  } else {
    Vue.use(jocommon)
    require('./assets/css/common.scss')
    new Vue({
      render: h => h(App)
    }).$mount('#app')
  }
  if (Vue.prototype.layout === 'rc' || hideCopyright === 1){
    $('#page-foot').css('display','none')
  }

  function _title (articleTitleData) {
    if (Array.isArray(articleTitleData)) {
      articleTitleData.forEach((item, index) => {
        if (item.name === 'text') {
          articleTitle += item.data
        } else if (item.name === 'inlineformula') {
          item.data.forEach((mathItem, mathIndex) => {
            if (mathItem.data && mathItem.data.math) {
              articleTitle += mathItem.data.math.replace(/<[^<>]+>/g,'');
            }
          })
        }else if(item.name === 'xref' && item.data.type!=='fn'){
          articleTitle += item.data.text
        }
        else if(!item.data.type || item.data.type!=='fn'){
          _title(item.data)
        }
      })
    } else {
      articleTitle += articleTitleData
    }
  }

  function parseParam () {
    let theme = ''
    let rcLanguage = ''
    if (location.search && location.search.indexOf('?') > -1) {
      let str = location.search.slice(1)
      let paras = str.split('&')
      for (let i = 0; i < paras.length; i++) {
        let para = paras[i].split('=')
        if (para[0] === 'theme') {
          theme = para[1]
        } else if (para[0] === 'lang' && (para[1]=='zh' || para[1] == 'en')) {
          rcLanguage = para[1]
        } else if(para[0] === 'showTop'){
          if (para[1] == '0'){
            Vue.prototype.showTopbar = false;
          }
        } else if(para[0] === 'hideLink'){
          if (para[1] == '1'){
            Vue.prototype.showLink = false;
          }
        } else if(para[0] === 'trans'){
          if (para[1] == '1'){
            Vue.prototype.showTrans = true;
          }
        } else if(para[0] === 'hideCopyright'){
          if (para[1] == '1'){
            hideCopyright = 1
          }
        } else if(para[0] === 'layout'){
          if (para[1] == '1'){
            Vue.prototype.layout = "rc";
            Vue.prototype.showTopbar = false;
          }
        } else if (para[0] === 'activeTab' && !Vue.prototype.showTopbar) {
          switch (para[1]) {
            case '1':
              Vue.prototype.component = 'carousel'
              break
            case '2':
              Vue.prototype.component = 'references'
              break
            case '3':
              Vue.prototype.component = 'author'
              break
            case '4':
              Vue.prototype.component = 'publish'
              break
          }
        } else if (para[0] === 'showBaidu') {
          if (para[1] == '0') {
            Vue.prototype.showBaidu = false;
          }
        } else if (para[0] === 'showGoogle') {
          if (para[1] == '1') {
            Vue.prototype.showGoogle = true;
          }
        } else if (para[0] === 'hideFootnote') {
          if (para[1] == '1') {
            Vue.prototype.hideFootnote = true;
          }
        } else {
          console.log('接收到非法参数，显示默认网刊')
        }
      }
      if (rcLanguage !== '' && Vue.prototype.ARTICLE.titlegroup.articletitle.length > 1) {
        Vue.prototype.ARTICLE.defaultlang = rcLanguage
      } else if (rcLanguage === '') {
        rcLanguage = Vue.prototype.ARTICLE.defaultlang
      }
      if (theme != undefined && theme != '') {
        let url
        if (process.env.NODE_ENV === 'production') {
          let linkElement = document.getElementsByTagName('link')
          for (let i = 0; i < linkElement.length; i++) {
            let href = linkElement[i].href
            if (href.indexOf('.css') > 0) {
              url = href
            }
          }
          let link = document.createElement('link')
          link.type = 'text/css'
          link.rel = 'stylesheet'
          link.href = url.replace('/app/', '/' + theme + '/')
          document.head.appendChild(link)
        } else {
          require('./assets/themes/' + theme + '/css/index.scss')
        }
        document.body.className = 'append-css-' + theme
      }
    }
  }
}

if (process.env.NODE_ENV === 'production') {
  // 本地数据包
  if (window.data != null) {
    Vue.prototype.ARTICLE = window.data
    _renderArticle()
  } else {
    // 网络请求数据
    Bus.$http.get(window.location.pathname + 'data.json').then(response => {
      Vue.prototype.ARTICLE = JSON.parse(response.bodyText)
      _renderArticle()
    }, response => {
      alert('访问目标网页失败！')
    })
  }
} else {
  Bus.$http.get('/getData/data.json').then(response => {
    Vue.prototype.ARTICLE = JSON.parse(response.bodyText)
    _renderArticle()
  }, response => {
    alert('访问目标网页失败！')
  })
}



// WEBPACK FOOTER //
// ./src/main.js